var map = {
	"./ion-action-sheet.entry.js": [
		48451,
		8451
	],
	"./ion-alert.entry.js": [
		18550,
		8550
	],
	"./ion-app_8.entry.js": [
		91006,
		1006
	],
	"./ion-avatar_3.entry.js": [
		9169,
		9169
	],
	"./ion-back-button.entry.js": [
		9112,
		9112
	],
	"./ion-backdrop.entry.js": [
		59389,
		9389
	],
	"./ion-button_2.entry.js": [
		17733,
		7733
	],
	"./ion-card_5.entry.js": [
		82011,
		2011
	],
	"./ion-checkbox.entry.js": [
		3562,
		3562
	],
	"./ion-chip.entry.js": [
		62185,
		2185
	],
	"./ion-col_3.entry.js": [
		17478,
		7478
	],
	"./ion-datetime_3.entry.js": [
		49440,
		9440
	],
	"./ion-fab_3.entry.js": [
		56608,
		6608
	],
	"./ion-img.entry.js": [
		88014,
		8014
	],
	"./ion-infinite-scroll_2.entry.js": [
		16270,
		6270
	],
	"./ion-input.entry.js": [
		42865,
		2865
	],
	"./ion-item-option_3.entry.js": [
		964,
		964
	],
	"./ion-item_8.entry.js": [
		97419,
		7419,
		3262
	],
	"./ion-loading.entry.js": [
		59740,
		9740
	],
	"./ion-menu_3.entry.js": [
		19936,
		9936
	],
	"./ion-modal.entry.js": [
		53731,
		3731
	],
	"./ion-nav_2.entry.js": [
		14288,
		4288
	],
	"./ion-popover.entry.js": [
		36560,
		6560
	],
	"./ion-progress-bar.entry.js": [
		55051,
		5051
	],
	"./ion-radio_2.entry.js": [
		62932,
		2932
	],
	"./ion-range.entry.js": [
		26074,
		6074
	],
	"./ion-refresher_2.entry.js": [
		28290,
		8290
	],
	"./ion-reorder_2.entry.js": [
		53479,
		3479
	],
	"./ion-ripple-effect.entry.js": [
		84905,
		4905
	],
	"./ion-route_4.entry.js": [
		85095,
		5095
	],
	"./ion-searchbar.entry.js": [
		57421,
		7421
	],
	"./ion-segment_2.entry.js": [
		53806,
		3806
	],
	"./ion-select_3.entry.js": [
		97421,
		6306
	],
	"./ion-slide_2.entry.js": [
		34208,
		4208
	],
	"./ion-spinner.entry.js": [
		63046,
		3046
	],
	"./ion-split-pane.entry.js": [
		34774,
		4774
	],
	"./ion-tab-bar_2.entry.js": [
		33196,
		3196
	],
	"./ion-tab_2.entry.js": [
		13965,
		3965
	],
	"./ion-text.entry.js": [
		42516,
		2516
	],
	"./ion-textarea.entry.js": [
		12117,
		2117
	],
	"./ion-toast.entry.js": [
		24617,
		4617
	],
	"./ion-toggle.entry.js": [
		29125,
		9125
	],
	"./ion-virtual-scroll.entry.js": [
		19480,
		9480
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 379;
module.exports = webpackAsyncContext;